export enum alertTypeEnum {
  company = "company",
  watchlist = "watchlist",
}
